import { render, staticRenderFns } from "./meb-home.vue?vue&type=template&id=454811d1&"
import script from "./meb-home.vue?vue&type=script&lang=js&"
export * from "./meb-home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports